import PageHeader from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import LeadForm from "@/components/common/LeadForm";

const Enquiry = () => (
  <div>
    <PageHeader
      eyebrow="Send an Enquiry"
      title="Tell us what you need"
      subtitle="Whether it's a machine, a retrofit, or a service — share your requirement and our engineers will get back to you promptly."
      image="https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?auto=format&fit=crop&w=1400&q=80"
    />
    <section className="py-12 md:py-20">
      <div className="max-w-[760px] mx-auto px-6 md:px-12">
        <Reveal className="bg-white border border-[#0055FF]/30 rounded-2xl p-8 md:p-10">
          <LeadForm kind="enquiry" />
        </Reveal>
      </div>
    </section>
  </div>
);

export default Enquiry;
